module.exports = "<svg viewBox=\"0 0 55.1 61.1\"><path d=\"M10 61.1V0\" class=\"st0\"></path><path d=\"M45.1 61.1V0\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/quotes.svg
// module id = 306
// module chunks = 1